import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Chip from "@mui/material/Chip";
import Divider from "@mui/material/Divider";

import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";
import KeyboardDoubleArrowUpIcon from "@mui/icons-material/KeyboardDoubleArrowUp";

import { TVehicle } from "types";

import { Creole } from "./Creole";

import { cleanMD } from "./helper";
import { Markdown } from "./Markdown";

interface IAdditionalOptions {
  vehicle: TVehicle;
  paperProps?: any;
  variant?: string;
  height?: number;
}

const Options: React.FC<IAdditionalOptions> = ({
  paperProps = {
    variant: "outlined",
    sx: { p: 2 },
  },
  vehicle,
  height = 200,
}): JSX.Element | null => {
  const [expanded, setExpanded] = React.useState<boolean>(false);
  const { formatMessage: t } = useIntl();
  const { zus_ausstattung_layout: additionalOptions } = vehicle;
  if (!additionalOptions) return null;

  const cleanedMarkdown = cleanMD(additionalOptions);

  return (
    <Paper
      variant="outlined"
      {...paperProps}
      data-testid="page-detail-component-AdditionalOptions"
    >
      <Typography variant="h5" component="h2">
        <FormattedMessage
          id="pages.detail.additionalOptions.label"
          defaultMessage="Zusätzliche Ausstattung"
        />
      </Typography>
      <Grid
        container
        spacing={2}
        sx={{ maxHeight: expanded ? "none" : height, overflow: "hidden" }}
      >
        <Grid size={12} sx={{ columnWidth: "40ch" }}>
          <Creole text={cleanedMarkdown} />
        </Grid>
      </Grid>
      <Divider sx={{ mt: 2 }}>
        <Chip
          label={t({ id: "common.more", defaultMessage: "Mehr" }).toLowerCase()}
          size="medium"
          variant="outlined"
          icon={<KeyboardDoubleArrowDownIcon />}
          onClick={() => setExpanded(true)}
          sx={{ display: !expanded ? "inlineBlock" : "none" }}
        />
        <Chip
          label={t({
            id: "common.less",
            defaultMessage: "Weniger",
          }).toLowerCase()}
          size="medium"
          variant="outlined"
          icon={<KeyboardDoubleArrowUpIcon />}
          onClick={() => setExpanded(false)}
          sx={{ display: expanded ? "inlineBlock" : "none" }}
        />
      </Divider>
    </Paper>
  );
};

export default Options;
